import React from "react";
import {
  bar, content, img, urlBox, divider
} from "./style.mod.scss";
import getImagePath from "helpers/get-image-path";
import Link from "components/link";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper";
import { useMediaQuery } from "react-responsive";

const Bar = ({ data }) => {
  const wrapperStyle = {};
  if (data.txtColor && data.txtColor.hex) wrapperStyle.color = data.txtColor.hex;
  if (data.bgColor && data.bgColor.hex) wrapperStyle.backgroundColor = data.bgColor.hex;

  const { textAndIcons } = data;
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  var settings = {
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false
    },
    loop: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    modules: [Autoplay, Pagination],
    pagination: { clickable: true },
    navigation: { clickable: true },
    effect: "fade",
    fadeEffect: { crossFade: true },
  };

  return (
    <div className={`${bar} `} style={wrapperStyle}>
      {isMobile ? <Swiper {...settings}>
        {textAndIcons?.map((item, i) => (
          <SwiperSlide key={i}>
            <span className={content}>
              <Link to={item?.link} className={urlBox}>
                <img className={img} src={getImagePath(item?.icon)} alt={item?.icon?.alt} />
                <span>{item?.text}</span>
              </Link>
            </span>

          </SwiperSlide>
        ))}

      </Swiper> :
        <>
          {textAndIcons?.map((item, i) => (
            <div key={i}>
              <span className={content}>
                <Link to={item?.link} className={urlBox}>
                  <img className={img} src={getImagePath(item?.icon)} alt={item?.icon?.alt} />
                  <span>{item?.text}</span>
                </Link>
              </span>
              <div className={divider}></div>
            </div>
          ))}
        </>}
    </div>
  );
};

export default Bar;
